enum GroupItemPremission {
  Prem_GroupItem_Show_Prem = 'Prem_GroupItem_Show_Prem',
  Prem_GroupItem_Create_Prem = 'Prem_GroupItem_Create_Prem',
  Prem_GroupItem_Update_Prem = 'Prem_GroupItem_Update_Prem',
  Prem_GroupItem_Delete_Prem = 'Prem_GroupItem_Delete_Prem',
}

export default GroupItemPremission;
